<smt-modal [(isActive)]="confirmModalActive"  [allowDropDownOverflow]="true" [disableFooter]="false" [disableHeader]="true" 
    (acceptEvent)="confirmYes(rowNameToDelete)" (rejectEvent)="confirmModalActive = false" 
    acceptText="Yes" acceptCssClass="button primary" rejectText="No" rejectCssClass="button cancel">
   <div role="body">
    The deletion of this activity category will cause your staffing grid to be redrawn.  Do you want to continue?
   </div>
</smt-modal>
<div class="form-group">
  <label>Type of Work Template</label>
  <select required id="typeOfWorkTemplateDropDown" name="typeOfWorkTemplate" [disabled]="hasConfiguration || readOnly"
          (change)="onSelectTypeofWorkTemplete()" [(ngModel)]="configuration.typeOfWorkTemplate">
    <option [value]="null"></option>
    <option value="acuity">Activity</option>
    <option value="total">Total Units of Service</option>
  </select>
</div>
<div class="form-group">
  <label for="uosCategoryDropDown">UOS Category</label>
  <select required name="uosCategory" id="uosCategoryDropDown" [disabled]="hasConfiguration || readOnly" [(ngModel)]="configuration.unitOfServiceId">
    <option [value]="null"></option>
    <option *ngFor="let unitOfService of unitsOfService" [ngValue]="unitOfService.id">
      {{unitOfService.category}}
    </option>
  </select>
</div>
<div class="form-group" [hidden]="configuration.typeOfWorkTemplate !== 'acuity'">
  <label>Target WHPUOS</label>
  <input [(ngModel)]="configuration.targetWHPUOS" type="number" required name="targetWHPUOS" max="9999" min="0"
         pattern="[0-9]{1,4}(\.[0-9]{0,3})?" [disabled]="configuration.typeOfWorkTemplate !== 'acuity' || readOnly">
</div>
<div class="workflow-input-group" [hidden]="configuration.typeOfWorkTemplate !== 'total'">
  <label>Target WHPUOS Number</label>
  <div class="workflow-input-labels">
    <span>Variable</span>
    <span>Fixed</span>
    <span>Total</span>
  </div>
  <div class="workflow-input">
    <input type="number" min="0" pattern="[0-9]{1,4}(\.[0-9]{0,2})?" required name="variableTargetWHPUOS" [(ngModel)]="configuration.variableTargetWHPUOS"  [disabled]="configuration.typeOfWorkTemplate !== 'total' || readOnly">
    <input type="number" min="0" pattern="[0-9]{1,4}(\.[0-9]{0,2})?" required name="fixedTargetWHPUOS" [(ngModel)]="configuration.fixedTargetWHPUOS"  [disabled]="configuration.typeOfWorkTemplate !== 'total' || readOnly">
    <input type="number" disabled name="totalTargetWHPUOS" [ngModel]="totalTargetWHPUOS">
  </div>
  </div>
  <div class="form-group">
    <h3>Enter By</h3>
    <span class="inline warning" *ngIf="missingUosByBlock">
      <span class="icon-warning2"></span> Please select how frequently you want to enter units of service.</span>
    <ul class="options">
      <li>
        <label>
          <input type="radio" name="enterUOSByBlock" [value]="true" (change)="validate()" [attr.disabled]="isRadioButtonReadOnly"
                 [(ngModel)]="configuration.enterUOSByBlock" required>By Block
        </label>
      </li>
      <li>
        <label>
          <input type="radio" name="enterUOSByBlock" [value]="false" (change)="validate()" [attr.disabled]="isRadioButtonReadOnly"
                 [(ngModel)]="configuration.enterUOSByBlock">By Day
        </label>
      </li>
    </ul>
  </div>
  <section [hidden]="configuration.typeOfWorkTemplate !== 'acuity'">
    <div>
      <div>
        <h3>Activity Categories</h3>
        <span class="inline warning" *ngIf="missingAcuityCategories">
          <span class="icon-warning2"></span> Please add Activity Categories
        </span>
        <expandable-list-combo  
          [readOnly]="readOnly" 
          [OrderedList]="true" 
          infoLabel="Activity Category" 
          (orderUpdated)="orderUpdated($event)"   
          (rowsChange)="acuityCategoryChangeEvent($event)" 
          (emitWarning)="showAcuityWarning($event)" 
          acceptText="Add Activity Category"  
          (removeItemCallBack)="markConfirmModalActive($event)" 
          [columns]="acuityCategoryColumns" 
          [(rows)]="acuityCategoryRows" 
          [skipRowUpdate]="!isNewCostCenter && isFutureShiftBlockAvailable" >
      </expandable-list-combo>
      </div>
  </div>
  </section>
  
  <div [hidden]="configuration.typeOfWorkTemplate !== 'total'">
    <div class="form-group" [hidden]="readOnly">
      <h3>Total Units of Service</h3>
      <label>Add ons</label>
      <span class="inline warning" *ngIf="missingAddOns">
        <span class="icon-warning2"></span> Please select Add ons</span>
      <ul class="options">
        <li>
          <input type="radio" name="addOns" [value]="true" [disabled]="readOnly || isFutureShiftBlockAvailable" (change)="onChangeAddons()" [(ngModel)]="configuration.addOns"> Yes
        </li>
        <li>
          <input type="radio" name="addOns" [value]="false" [disabled]="readOnly  || isFutureShiftBlockAvailable" (change)="onChangeAddons()" [(ngModel)]="configuration.addOns"> No
        </li>
      </ul>
    </div>
    <div class="form-group" [hidden]="!readOnly">
      <label>Add ons</label>
      <input type="text" name="addOnsReadOnly" [readonly]="true" [value]="selectedTypeOfAddOns ? 'Yes' : 'No'">
    </div>
  </div>
  <div class="form-group" [hidden]="configuration.typeOfWorkTemplate !== 'acuity'">
    <h3>Room Types</h3>
    <span class="inline warning" *ngIf="missingHasRoomTypesCheckbox"><span class="icon-warning2"></span> Please select
      whether this cost center will collect data by room.</span>
    <ul class="options">
      <li>
        <label>
          <input type="radio" name="hasRoomTypes" [value]="true" (change)="validate()" [attr.disabled]="isRadioButtonReadOnly" [(ngModel)]="configuration.hasRoomTypes">Yes
        </label>
      </li>
      <li>
        <label>
          <input type="radio" name="hasRoomTypes" [value]="false" (change)="validate()" [attr.disabled]="isRadioButtonReadOnly" 
                 [(ngModel)]="configuration.hasRoomTypes">No
        </label>
      </li>
    </ul>
  </div>
  <div class="form-group" *ngIf="configuration.hasRoomTypes">
    <label><input type="checkbox" name="defaultToNoOccupancy" [(ngModel)]="configuration.defaultToNoOccupancy" [disabled]="readOnly">
      Default to No Occupancy
    </label>
  </div>

  <section *ngIf="configuration.hasRoomTypes" class="form-group inline-control config-list">
    <h3 for="roomTypeName">Room Types</h3>
    <div *ngIf="!readOnly" class="form-group compact inline-control">
      <input name="roomTypeName" [(ngModel)]="newRoomType" type="text" maxlength="25" />
      <button (click)="addRoomType()" class="compact"><span class="icon-plus"></span> Add Room Type</button>
    </div>
    <div *ngIf="configuration.roomTypes?.length > 0">
      <table role="list"class="condensed">
        <thead>
          <tr>
            <th>Room Type</th>
            <th></th>
          </tr>
        </thead>
        <tr class="compact" *ngFor="let roomType of configuration.roomTypes; let i = index;">
          <td>{{roomType.name}}</td>
          <td class="form-group right">
            <button type="button" *ngIf="!readOnly" class="compact"  id="remove-room-type" (click)="removeRoomType(i)">
              <span class="icon-bin"></span> Remove
            </button>
          </td>
        </tr>
      </table>
    </div>
  </section>
    <section *ngIf="configuration.roomTypes?.length > 0" class="form-group inline-control config-list">
      <h3>Room Names</h3>
      <expandable-list-combo [readOnly]="readOnly" [OrderedList]="true" infoLabel="Room Name" [groupByPlaceHolder]="'Room Type'" [groupArray]="roomGroupArray" (orderUpdated)="orderUpdated($event)" (rowsChange)="roomInfoChangeEvent($event)" (emitWarning)="showRoomInfoWarning($event)" acceptText="Add Room Name"  (removeItemCallBack)="removeRoom($event)" 
       [columns]="roomInfoColumns" [(rows)]="roomInfoRows" >
    </expandable-list-combo>
  </section>

    <span class="inline warning" *ngIf="configuration.roomTypes?.length > 0 && missingRooms">
      <span class="icon-warning2">
      </span> Please add a room name for every room type.</span>
  
